import styled from "styled-components";

export const StyledBlockHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const StyledBlockIcon = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #eef3fc;
  border: 1px solid rgba(85, 138, 224, 0.2);
  border-radius: 50%;
`;

export const StyledFieldLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 4px;
`;

export const StyledFieldHelper = styled.p`
  margin: 0 0 8px;
  font-size: 12px;
  line-height: 16px;
  color: #878b92;
`;

export const StyledTextInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  font-size: 14px;
  border: 1px solid #d9d9de;
  border-radius: 6px;
  outline: none;
  transition: border-color 120ms ease;
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  &:focus {
    border-color: var(--solution-primary-color);
  }
`;

export const StyledBranchList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
`;

export const StyledAddBranchButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--solution-primary-color);
  font-size: 13px;
  font-weight: 500;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
